<template>
  <v-app style="background-color:white;margin-top:120px">

    <v-card class="form-container" flat style="margin-top:-10px">
      <v-form ref="form" v-model="valid" lazy-validation>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md6 style="padding-right:5px">
                    <v-text-field v-model="form.name" label="Name *" :rules="emptyRule" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-text-field v-model="form.mobileNumber" label="Mobile No *" :rules="[rules.mobileno]" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="form.locality" label="Locality *"  :rules="emptyRule" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="form.address" label="Address *"  :rules="emptyRule" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4 style="padding-right:5px">
                    <v-text-field v-model="form.pinCode" label="Pincode *" type="number"  :rules="emptyRule" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4 style="padding-right:5px">
                    <v-text-field v-model="form.cityDistrictTown" label="City/Discrict/Town *"  :rules="emptyRule" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4>
                    <v-autocomplete
              v-model="selectedState"
              :items="states"
              color="primary"
              label="Select State *"
              item-text="name"
              item-value="id"
              :rules="emptyRule" 
              required
            ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="form.landMark" label="Landmark *"  :rules="emptyRule" required></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <b-form-radio-group
                   v-model="selected"
                  :options="options"
                  ></b-form-radio-group>
                  </v-flex>

                  <v-flex xs12 style="text-align:right">
                    <v-btn depressed color="#e53935" dark @click="back()">Cancel</v-btn>
                    <v-btn depressed :loading="btnSave1" color="primary" dark @click="onSubmit()">Update</v-btn>
                  </v-flex>
                </v-layout>
              </v-form>
    </v-card>
  </v-app>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      edit: false,
      title: "Create Counselling",
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      btnSave: false,

      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
      mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
      },
      valid: true,
      roleType: sessionStorage.roles,
      btnSave1: false,
      address: [],
      addressDialog: false,
      selectedAddress: {
        id: null,
        name: null,
        mobileNumber: null,
        address: null,
        pinCode: null
      },
      selectedAddress1: null,

      form: {
        name: null,
        mobileNumber: null,
        pinCode: null,
        address: null,
        landMark: null,
        locality: null,
        cityDistrictTown: null,
        alternateNumber: null
      },

      selected: "Home Address",
      options: ["Home Address", "Office Address"],

      selected1: "Cash on Delivery",
      options1: ["Cash on Delivery", "Online Payment"],

      states: [],
      selectedState: null,
    };
  },

  mounted() {
    this.axios
      .get(config.API + `MyProfile/${this.$route.params.id}`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        this.form = res.data;
        this.selectedState = res.data.stateCode;
      });
      this.axios
        .get(config.API + `States`, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.states = res.data;
          this.$Progress.finish();
        });
    },

  methods: {
    back() {
      this.$router.go(-1);
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave1 = true;
        this.axios
          .put(
            config.API + `CustomerAddresses/${this.$route.params.id}`,
            {
              id: JSON.parse(this.$route.params.id),
              name: this.form.name,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              pinCode: JSON.parse(this.form.pinCode),
              address: this.form.address,
              locality: this.form.locality,
              cityDistrictTown: this.form.cityDistrictTown,
              landMark: this.form.landMark,
              alternateNumber: this.form.alternateNumber,
              stateCode: JSON.parse(this.selectedState),
              addressType: this.selected
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Successfully updated");
            this.$router.go(-1);
          })
          .catch(err => {
            this.btnSave1 = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    }
  }
};
</script>

<style>
.bckgrnd {
  background-color: #424242;
  background-size:cover !important;
}
</style>
